import { useEffect } from 'react';

export const useOnClickOutside = (ref: any, handler: any, onClickEventListener: string) => {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener(onClickEventListener, listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener(onClickEventListener, listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
